(function () {
  var root = document.querySelector('[data-plews-cart-drawer]');
  if (!root) return;

  var drawer = root.querySelector('.pcd-drawer');
  var closeBtns = root.querySelectorAll('[data-pcd-close]');
  var itemsWrap = root.querySelector('[data-pcd-items]');
  var emptyWrap = root.querySelector('[data-pcd-empty]');
  var subtotalEl = root.querySelector('[data-pcd-subtotal]');

  function formatMoney(cents) {
    var value = (Number(cents || 0) / 100);

    try {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN'
      }).format(value);
    } catch (e) {
      return '$' + value.toFixed(2);
    }
  }

  function updateHeaderCount(count) {
    var selectors = [
      '[data-cart-count]',
      '[data-header-cart-count]',
      '.cart-count',
      '.cart-count-bubble span',
      '#cart-icon-bubble span'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = count;
      });
    });
  }

  function openDrawer() {
    root.classList.add('is-open');
    document.body.classList.add('pcd-lock');

    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
    }

    refreshCart();
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    document.body.classList.remove('pcd-lock');

    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderCart(cart) {
    updateHeaderCount(cart.item_count || 0);

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price || 0);
    }

    if (!itemsWrap || !emptyWrap) return;

    if (!cart.items || !cart.items.length) {
      emptyWrap.style.display = 'grid';
      itemsWrap.innerHTML = '';
      return;
    }

    emptyWrap.style.display = 'none';

    itemsWrap.innerHTML = cart.items.map(function (item) {
      var image = item.image
        ? '<img src="' + item.image + '&width=220" alt="' + escapeHtml(item.product_title) + '">'
        : '';

      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="pcd-item-variant">' + escapeHtml(item.variant_title) + '</div>'
        : '';

      return [
        '<article class="pcd-item" data-pcd-line="' + item.key + '">',
          '<a class="pcd-item-media" href="' + item.url + '">' + image + '</a>',
          '<div class="pcd-item-info">',
            '<a class="pcd-item-title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>',
            variant,
            '<div class="pcd-item-bottom">',
              '<div class="pcd-qty">',
                '<button type="button" data-pcd-qty-minus data-key="' + item.key + '">-</button>',
                '<span>' + item.quantity + '</span>',
                '<button type="button" data-pcd-qty-plus data-key="' + item.key + '">+</button>',
              '</div>',
              '<div class="pcd-item-price">' + formatMoney(item.final_line_price) + '</div>',
            '</div>',
            '<button class="pcd-remove" type="button" data-pcd-remove data-key="' + item.key + '">Eliminar</button>',
          '</div>',
        '</article>'
      ].join('');
    }).join('');
  }

  function refreshCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      })
      .catch(function (error) {
        console.warn('Plews cart drawer error:', error);
      });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  function addToCart(form) {
    var formData = new FormData(form);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (error) {
            throw error;
          });
        }

        return response.json();
      })
      .then(function () {
        return refreshCart();
      })
      .then(function () {
        openDrawer();
      })
      .catch(function (error) {
        console.warn('Plews add to cart error:', error);

        var message = error && error.description
          ? error.description
          : 'No se pudo agregar el producto al carrito.';

        alert(message);
      });
  }

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

  root.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('[data-pcd-remove]');
    var minusBtn = event.target.closest('[data-pcd-qty-minus]');
    var plusBtn = event.target.closest('[data-pcd-qty-plus]');

    if (removeBtn) {
      changeLine(removeBtn.getAttribute('data-key'), 0);
      return;
    }

    if (minusBtn || plusBtn) {
      var btn = minusBtn || plusBtn;
      var key = btn.getAttribute('data-key');
      var itemEl = btn.closest('.pcd-item');
      var qtySpan = itemEl ? itemEl.querySelector('.pcd-qty span') : null;
      var currentQty = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;

      if (!currentQty || currentQty < 1) currentQty = 1;

      var nextQty = plusBtn ? currentQty + 1 : currentQty - 1;

      if (nextQty < 0) nextQty = 0;

      changeLine(key, nextQty);
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    var submitter = event.submitter;
    if (submitter && submitter.name === 'checkout') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    addToCart(form);
  }, true);

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-open-cart-drawer]');
    if (!trigger) return;

    event.preventDefault();
    openDrawer();
  });

  window.PlewsCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshCart,
    add: addToCart
  };

  refreshCart();
})();